import { type ComponentType } from 'react'

import { type QuickTourTarget } from '../../build-tour-steps'
import { HeroOutbox } from './hero-outbox'
import { HeroReminders } from './hero-reminders'
import { HeroUpcoming } from './hero-upcoming'
import { HeroWelcome } from './hero-welcome'

/** Illustration shown above each step's copy. Chat reuses the brand mark. */
export const TOUR_HEROES: Record<QuickTourTarget, ComponentType> = {
  toolbar: HeroWelcome,
  upcoming: HeroUpcoming,
  reminders: HeroReminders,
  actions: HeroOutbox,
  chat: HeroWelcome,
}
